"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _fi = require("react-icons/fi");

var _fileUploadText = _interopRequireDefault(require("../../../assets/icons/file-upload-text.svg"));

var _typography = _interopRequireDefault(require("../../typography"));

var _tooltip = _interopRequireDefault(require("../../tooltip"));

var _constants = require("../constants");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Preview = function Preview(_ref) {
  var file = _ref.file,
      setIsOpen = _ref.setIsOpen;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      base64File = _useState2[0],
      setBase64File = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      fileName = _useState4[0],
      setFileName = _useState4[1];

  var downloadRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (file) {
      setFileName((file === null || file === void 0 ? void 0 : file.name) || '');
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = function () {
        setBase64File(fileReader.result);
      };
    }
  }, [file]);

  var onDownloadClick = function onDownloadClick() {
    if (downloadRef !== null && downloadRef !== void 0 && downloadRef.current) {
      downloadRef.current.click();
    }
  };

  return file && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.previewContainer
  }, base64File && file.type.includes('image') && /*#__PURE__*/_react.default.createElement("img", {
    className: _constants.classes.previewImageContainer,
    src: base64File,
    alt: fileName,
    onClick: function onClick() {
      return file.type.includes('image') && setIsOpen(true);
    }
  }), !file.type.includes('image') && /*#__PURE__*/_react.default.createElement("img", {
    className: _constants.classes.previewNonImageContainer,
    role: "img",
    alt: _constants.nonImageAltText,
    src: _fileUploadText.default
  }), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    title: file.name,
    position: "top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.previewFileName,
    onClick: onDownloadClick
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, fileName))), /*#__PURE__*/_react.default.createElement("a", {
    className: "file-viewer-download-link",
    ref: downloadRef,
    href: base64File,
    download: file.name
  }));
};

var _default = Preview;
exports.default = _default;